import { authHeader } from './authservice/auth-header';

export const addressService = {
    fetchList,
    fetchItem,
    store,
    destroy,
    update,
    importList,
    exportList
};

function fetchItem(id) {
    const endpoint = `/contactAddress/crud/${id}`;

    if (window.axios) {
        return window.axios.get(endpoint).then(response => {
            return response.data.data;
        });
    }

    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(endpoint, requestOptions).then(handleResponse);
}

function fetchList(id) {
    const endpoint = `/contactAddress/listContactAddress/${id}`;

    if (window.axios) {
        return window.axios.get(endpoint).then(response => {
            return response.data;
        });
    }

    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(endpoint, requestOptions).then(handleResponse);
}

function store(data) {
    const endpoint = `/contactAddress/crud`;

    if (window.axios) {
        return window.axios.post(endpoint, data).then(response => {
            return response.data;
        });
    }

    const requestOptions = {
        method: 'POST',
        headers: authHeader()
    };

    return fetch(endpoint, requestOptions).then(handleResponse);
}

function update(id, data) {
    const endpoint = `/contactAddress/crud/${id}`;

    if (window.axios) {
        return window.axios.patch(endpoint, data).then(response => {
            return response.data;
        });
    }

    const requestOptions = {
        method: 'PATCH',
        headers: authHeader()
    };

    return fetch(endpoint, requestOptions).then(handleResponse);
}

function destroy(id) {
    const endpoint = `/contactAddress/crud/${id}`;

    if (window.axios) {
        return window.axios.delete(endpoint).then(response => {
            return response.data;
        });
    }

    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };

    return fetch(endpoint, requestOptions).then(handleResponse);
}

function importList(data) {
    const endpoint = `/contactAddress/import`;

    if (window.axios) {
        return window.axios.post(endpoint, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => {
            return response.data;
        });
    }

    const requestOptions = {
        method: 'POST',
        headers: authHeader()
    };

    return fetch(endpoint, requestOptions).then(handleResponse);
}

function exportList(id) {
    const endpoint = `/contactAddress/export/${id}`;

    if (window.axios) {
        return window.axios.get(endpoint, {responseType: 'blob'}).then(response => {
            const link = document.createElement('a');
            link.href = URL.createObjectURL(response.data);
            link.download = getFileName(response.headers['content-disposition'], `export_${id}.xlsx`);
            link.click();
            setTimeout(() => URL.revokeObjectURL(link.href), 0);

            return response.status;
        });
    }

    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(endpoint, requestOptions).then(handleResponse);
}

// Fájlnév a Content-Disposition fejlécből; az ékezetes filename* változat elsőbbséget élvez
function getFileName(contentDisposition, fallback) {
    const encoded = /filename\*=UTF-8''([^;]+)/i.exec(contentDisposition || '');
    if (encoded) {
        return decodeURIComponent(encoded[1]);
    }

    const plain = /filename="?([^";]+)"?/i.exec(contentDisposition || '');
    return plain ? plain[1] : fallback;
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}
